module.exports = __webpack_public_path__ + "img/1.489701f1.jpg";